import getCookie from "utils/cookie";

const getAuthToken = () => localStorage.getItem("token");
const getCSRFToken = () => getCookie("CSRF-TOKEN");

export { getAuthToken, getCSRFToken };
